<cc-icon
    size="large"
    [highlight]="isHovered"
    [icon]="shown ? 'chevron-right' : 'chevron-left'"
    (iconClicked)="toggle()"
>
</cc-icon>
<span class="table-toggle-text">{{text}}</span>

